import React, {useState} from 'react';

import { ReactComponent as EditIcon } from '../images/edit.svg';
import { ReactComponent as CloseIcon } from '../images/x.svg';

const SubItem = ({text, text2, slow, edited, deleted}) => {
  let [isFocused, setIsFocused] = useState(false);

  return (
    <div style={{color: 'white',
                 marginTop: '10px',
                 display: 'flex',
                 justifyContent: 'space-between',
                 alignItems: 'center',
                 backgroundColor: isFocused ? '#222' : 'transparent',
                 padding: '5px 0px',
                }}
         onMouseEnter={() => setIsFocused(true)}
         onMouseLeave={() => setIsFocused(false)} >
      <div style={{display: 'flex',
                   width: '100%',
                   flexDirection: 'row',
                   gap: '10px',
                   alignItems: 'center',
                   padding: '5px 10px',
                  }}>
        <span style={{color: 'white',
                      fontSize: '14px',
                      padding: '5px 10px',
                      width: '200px',
                     }} >
          {text}
        </span>
        {text2 && (
          <span style={{color: 'white',
                        fontSize: '14px',
                        padding: '5px 10px',
                        width: '100px',
                        textAlign: 'center',
                        backgroundColor: '#222',
                        borderRadius: '5px',
                       }} >
            {text2}
          </span>
        )}
        {slow && (
          <span style={{color: 'white',
                        fontSize: '14px',
                        padding: '5px 10px',
                        width: '100px',
                        textAlign: 'center',
                        backgroundColor: '#222',
                        borderRadius: '5px',
                       }} >
            slow
          </span>
        )}
      </div>
      {isFocused && (
        <div style={{display: 'flex',
                     flexDirection: 'row',
                     gap: '10px',
                     alignItems: 'center',
                     padding: '5px 10px',
                    }}>
          <EditIcon className='image'
                    style={{width: '15px',
                            height: '15px',
                            fill: 'white',
                            cursor: 'pointer',
                           }}
                    onClick={edited} />
          <CloseIcon className='image'
                     style={{width: '15px',
                             height: '15px',
                             fill: 'red',
                             cursor: 'pointer',
                            }}
                     onClick={deleted} />
        </div>
      )}
      {!isFocused && <div />}
    </div>
  );
}

export default SubItem;
